/** Unified MIME for dragging any calendar cell item. */
export const CALENDAR_ITEM_DRAG_MIME = 'application/vnd.vo2.calendar-item';

/** @deprecated Use CALENDAR_ITEM_DRAG_MIME — kept for backward compatibility. */
export const CALENDAR_METRIC_DRAG_MIME = 'application/vnd.vo2.calendar-metric';

export type CalendarItemDragKind = 'workout' | 'metric' | 'health_document' | 'event' | 'note';

export interface CalendarItemDragPayload {
  kind: CalendarItemDragKind;
  sourceDate: string;
  sourceUserId: number;
  label: string;
  workoutId?: number;
  uniqueCode?: string;
  healthDocumentId?: number;
  eventId?: number;
  noteId?: number;
}

export function isCalendarItemDrag(e: React.DragEvent | DragEvent): boolean {
  const types = Array.from(e.dataTransfer?.types ?? []);
  return types.includes(CALENDAR_ITEM_DRAG_MIME) || types.includes(CALENDAR_METRIC_DRAG_MIME);
}

export function parseCalendarItemDragPayload(raw: string): CalendarItemDragPayload | null {
  try {
    const payload = JSON.parse(raw) as CalendarItemDragPayload;
    if (!payload?.kind || !payload?.sourceDate) return null;
    return payload;
  } catch {
    return null;
  }
}

/** Attach drag payload to a DataTransfer (HTML5 drag). */
export function setCalendarItemDragData(e: React.DragEvent, payload: CalendarItemDragPayload): void {
  e.dataTransfer.effectAllowed = 'move';
  const token =
    payload.kind === 'metric'
      ? payload.uniqueCode
      : payload.kind === 'workout'
        ? String(payload.workoutId)
        : payload.kind === 'health_document'
          ? String(payload.healthDocumentId)
          : payload.kind === 'event'
            ? String(payload.eventId)
            : String(payload.noteId);
  e.dataTransfer.setData('text/plain', token ?? '');
  e.dataTransfer.setData(CALENDAR_ITEM_DRAG_MIME, JSON.stringify(payload));
}
